import React from 'react';
import { useTranslation } from 'react-i18next';

interface StatusIndicatorProps {
  isUploading: boolean;
  isEvaluating: boolean;
  progress: number;
  evaluationId: string | null;
  error: string | null;
}

export const StatusIndicator: React.FC<StatusIndicatorProps> = ({
  isUploading,
  isEvaluating,
  progress,
  evaluationId,
  error,
}) => {
  const { t } = useTranslation();

  if (error) {
    return <div className="error">{error}</div>;
  }

  if (isUploading) {
    return (
      <div className="progress-container">
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progress}%` }}
          ></div>
        </div>
      </div>
    );
  }

  if (isEvaluating && evaluationId) {
    return (
      <div className="evaluation-progress">
        <p>{t('evaluation.evaluating', { id: evaluationId })}</p>
        <div className="progress-bar animated">
          <div
            className="progress-bar-fill"
            style={{ width: '100%' }}
          ></div>
        </div>
        <p style={{ fontSize: '12px', color: '#666' }}>
          {t('evaluation.evaluatingStatus')}
        </p>
      </div>
    );
  }

  return null;
};
